import sorter from "fluent-sorter";

/** Local calendar minute as a sortable key (matches HH:mm shown in the UI). */
export const localMinuteKey = (isoOrMs: string | number | Date): number => {
	const date = isoOrMs instanceof Date ? isoOrMs : new Date(isoOrMs);
	if (Number.isNaN(date.getTime())) {
		return 0;
	}
	return (
		date.getFullYear() * 1e10 +
		(date.getMonth() + 1) * 1e8 +
		date.getDate() * 1e6 +
		date.getHours() * 100 +
		date.getMinutes()
	);
};

/** Oldest start first; same local minute → shorter duration first. */
export const sortEntriesOldestFirst = <T extends { readonly start: string; readonly timeDiff: number }>(
	entries: readonly T[]
): T[] =>
	entries.toSorted(
		sorter<T, number>((entry) => localMinuteKey(entry.start), "asc").thenBy((entry) => entry.timeDiff, "asc")
	);
